import {Box, styled} from "@mui/material";

export const NavItemTitleBox = styled(Box)(({theme}) => ({
    fontSize: "14px",
    margin: "0 0 8px 0",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "14px",
    color: "var(--text-color1)"
}));